export default __webpack_public_path__ + "static/screenFifthSectionEn-16fa0ca63a5a0bcfefbf73e0ddcf8640.webp";